module.exports = __webpack_public_path__ + "static/media/diamonds_9.f0b1d841.png";